<template>
  <div class="my-apps">
    <div class="apps-header">
      <van-icon name="arrow-left" @click="goBack" />
      <div>{{title}}</div>
    </div>
    <div class="apps-content">
      <ul class="app-list">
        <li v-for="(item,index) in list"
          :key="item.appId"
          class="app-list-item"
          @click="operationWyy(item.appId,item.appUrl)">
          <img :src="item.appImages"
          alt="">
          <div class="app-name">{{item.appName}}</div>
        </li>
        <!-- <li v-for="n in 5"
          :key="n"
          class="app-list-item"
        >
          <img src="../assets/images/getImg.gif"
          alt="">
          <div class="app-name">应用名称我</div>
        </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[],
      title:'',
    };
  },
  mounted(){
    this.list=this.$route.query.list
    this.title=this.$route.query.title
  },
  methods: {
    // 返回上一页
    goBack(){
      history.go(-1)
    },
    // 打开微应用
    operationWyy(id, url){
      this.$common.appAccessStatistical(id);
      if (url == "http://" || url == "https://") {
        Toast("系统建设中，敬请期待！");
      } else {
        location.href = url;
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .my-apps{
    width:100%;
    height: 100%;
    background-image: url(../assets/images/top_bg.png);
    background-size: 100% 1.4rem;
    background-repeat: no-repeat;
  }
  .apps-header{
    padding-top:.21rem;
    height: 1.1rem;
    box-sizing: border-box;
    position:relative;
    color:#fff;
    font-size:.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .van-icon{
      position:absolute;
      left:.23rem;
      top:.56rem;
    }
  }
  .apps-content{
    width:100%;
    height: calc(100vh - 1.1rem);
    background:#fff;
    border-radius: .3rem;
    padding:0 .32rem;
    box-sizing: border-box;
  }
  .app-list { 
      padding-top: 0.43rem;
      width:100%;
      display: flex;
      flex-wrap: wrap;
      font-size: 0.26rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #555555;
      .app-list-item {
        width:25%;
        text-align: center;
        overflow-x: hidden;
        padding: 0 0.15rem;
        box-sizing: border-box;
        margin-bottom:.38rem;
        img {
          width: 0.765rem;
          height: 0.76rem;
          margin-bottom: 0.14rem;
        }
        .app-name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3; // 控制多行的行数
          -webkit-box-orient: vertical;
          text-align: center;
        }
      }
    }
</style>